import React from 'react';
import { showFeatures } from '../mock';
import { Check } from 'lucide-react';

const ShowDetails = () => {
  return (
    <section id="show-details" className="py-20 px-4 sm:px-6 lg:px-8 bg-black border-2 border-cyan rounded-3xl mb-8">
      <div className="container mx-auto">
        <h2 className="text-xl sm:text-[3.2vw] md:text-[3vw] lg:text-[2.85vw] text-center mb-16 text-gold font-semibold sm:whitespace-nowrap" style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}>
          Endorsed by Elvis' Inner Circle and Trusted Worldwide
        </h2>
        
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6 text-center">
            <div className="text-white/90 leading-relaxed space-y-4">
              <p>
                Gary's performance comes with an unparalleled seal of approval: it's officially backed by Elvis Presley's closest associates and celebrated by global clients such as ITV, BBC, Hilton Hotels, NABS and Guinness World Records.
              </p>
              
              <p>
                He has performed across the world, with shows in Dubai, Bahrain, Spain, Cyprus and Germany, further cementing his reputation as an International Elvis Tribute artist of the highest calibre.
              </p>
              
              <p>
                His many TV and Radio appearances include ITV's Dancing On Ice, and he has appeared alongside legends like Tom Jones and Elton John.
              </p>
              
              <p>
                Gary has also appeared in high-profile features such as OK! Magazine's "spoof" Vegas Weddings, including the celebrated ceremony of the late Jade Goody and Jack Tweed.
              </p>
              
              <p>
                This remarkable resume offers genuine social proof, boosting your confidence in booking Gary and reassuring every attendee that they're in for a world-class experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowDetails;
